<template>
  <div class="p-site-keyword-analysis-filter">
    <div class="p-site-keyword-analysis-filter__header">
      <h3 class="p-site-keyword-analysis-filter__title">
        表示データの絞り込み
      </h3>
    </div>
    <div class="p-site-keyword-analysis-filter__content">
      <perfect-scrollbar
        :options="{ suppressScrollX: true, minScrollbarLength: 10 }"
        ref="scroll"
      >
        <div class="p-site-keyword-analysis-filter__inner">
          <div class="c-fieldset c-fieldset--wrap">
            <p class="c-fieldset__header" :style="{ width: ' 100%' }">
              <span class="c-fieldset__title">保存した絞り込み条件</span>
              <span
                class="p-site-keyword-analysis-filter__delete-button"
                @click="openDeleteModal"
              >
                <Icon variant="gear_gy" :size="12" />確認・変更
              </span>
            </p>
            <div class="c-fieldset__content">
              <Select
                v-model="selectedFilterId"
                :options="filters"
                :selected="selectedFilterId"
                :required="true"
                @change="changeFilter"
              />
            </div>
          </div>
          <div class="c-fieldset c-fieldset--wrap">
            <p class="c-fieldset__header">
              <span class="c-fieldset__title">キーワード</span>
            </p>
            <div class="c-fieldset__content">
              <InputTags
                v-model="temp.keywords"
                placeholder="Enterで連続して指定できます"
                size="xs"
                ref="inputKeywords"
                @change="change"
              />
              <RadioGroup>
                <Radio
                  v-for="type in keywordMatchType"
                  :key="type.value"
                  :id="'keywordMatch-' + type.value"
                  name="keywordMatch"
                  v-model="temp.keywordMatch"
                  :value="type.value"
                  @change="change"
                >
                  {{ type.label }}
                </Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="c-fieldset c-fieldset--wrap">
            <p class="c-fieldset__header">
              <span class="c-fieldset__title">URL</span>
            </p>
            <div class="c-fieldset__content">
              <InputTags
                v-model="temp.urls"
                placeholder="Enterで連続して指定できます"
                size="xs"
                ref="inputUrls"
                @add="addUrl"
                @change="change"
              />
              <RadioGroup>
                <Radio
                  v-for="type in urlMatchType"
                  :key="type.value"
                  :id="'urlMatch-' + type.value"
                  name="urlMatch"
                  v-model="temp.urlMatch"
                  :value="type.value"
                  @change="change"
                >
                  {{ type.label }}
                </Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="c-fieldset">
            <p class="c-fieldset__header">
              <span class="c-fieldset__title">平均順位</span>
            </p>
            <div class="c-fieldset__content">
              <InputRange
                v-model="temp.rank"
                :defaultValue="defaultValue.rank"
                :range="range.rank"
                @change="change"
              />
            </div>
          </div>
          <div v-show="isInflux" class="c-fieldset">
            <p class="c-fieldset__header">
              <span class="c-fieldset__title">月間検索数</span>
            </p>
            <div class="c-fieldset__content">
              <InputRange
                v-model="temp.searchVolume"
                :defaultValue="defaultValue.searchVolume"
                :range="range.searchVolume"
                @change="change"
              />
            </div>
          </div>
          <div class="c-fieldset">
            <p class="c-fieldset__header">
              <span class="c-fieldset__title">表示回数</span>
            </p>
            <div class="c-fieldset__content">
              <InputRange
                v-model="temp.impressions"
                :defaultValue="defaultValue.impressions"
                :range="range.impressions"
                @change="change"
              />
            </div>
          </div>
          <div class="c-fieldset">
            <p class="c-fieldset__header">
              <span class="c-fieldset__title">クリック率(%)</span>
            </p>
            <div class="c-fieldset__content">
              <InputRange
                v-model="temp.ctr"
                :defaultValue="defaultValue.ctr"
                :range="range.ctr"
                :step="0.1"
                @change="change"
              />
            </div>
          </div>
          <div class="c-fieldset">
            <p class="c-fieldset__header">
              <span class="c-fieldset__title">流入数</span>
            </p>
            <div class="c-fieldset__content">
              <InputRange
                v-model="temp.influx"
                :defaultValue="defaultValue.influx"
                :range="range.influx"
                @change="change"
              />
            </div>
          </div>
          <template v-show="isConversion">
            <div v-show="isConversionDirect" class="c-fieldset">
              <p class="c-fieldset__header">
                <span class="c-fieldset__title">直接CV</span>
              </p>
              <div class="c-fieldset__content">
                <InputRange
                  v-model="temp.directConversion"
                  :defaultValue="defaultValue.directConversion"
                  :range="range.directConversion"
                  @change="change"
                />
              </div>
            </div>
            <div v-show="isConversionAssisted" class="c-fieldset">
              <p class="c-fieldset__header">
                <span class="c-fieldset__title">間接CV</span>
              </p>
              <div class="c-fieldset__content">
                <InputRange
                  v-model="temp.assistedConversion"
                  :defaultValue="defaultValue.assistedConversion"
                  :range="range.assistedConversion"
                  @change="change"
                />
              </div>
            </div>
            <div v-show="isConversionDirect" class="c-fieldset">
              <p class="c-fieldset__header">
                <span class="c-fieldset__title">直接CVR(%)</span>
              </p>
              <div class="c-fieldset__content">
                <InputRange
                  v-model="temp.directConversionRate"
                  :defaultValue="defaultValue.directConversionRate"
                  :range="range.directConversionRate"
                  :step="0.1"
                  @change="change"
                />
              </div>
            </div>
            <div v-show="isConversionAssisted" class="c-fieldset">
              <p class="c-fieldset__header">
                <span class="c-fieldset__title">間接CVR(%)</span>
              </p>
              <div class="c-fieldset__content">
                <InputRange
                  v-model="temp.assistedConversionRate"
                  :defaultValue="defaultValue.assistedConversionRate"
                  :range="range.assistedConversionRate"
                  :step="0.1"
                  @change="change"
                />
              </div>
            </div>
          </template>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="p-site-keyword-analysis-filter__save-button c-alertPos">
      <Button
        fsize="f12"
        variant="adddata"
        icon="plus_gn"
        :disabled="isLoading"
        @click="handleSaveClick"
      >
        現在の絞り込み条件を保存
      </Button>
      <Alert v-if="errorMessage" :style="{ 'z-index': 10 }">
        {{ errorMessage }}
      </Alert>
    </div>
    <div class="p-site-keyword-analysis-filter__footer">
      <Button
        fsize="f10"
        variant="border"
        icon="pageback"
        class="l-w-120"
        @click="reset"
      >
        絞り込みを解除
      </Button>
      <Button
        fsize="f10"
        variant="main"
        class="l-w-120"
        @click="handleFilterClick"
      >
        絞り込みを実行
      </Button>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Icon from '@/components/Icon';
import InputTags from '@/components/InputTags';
import InputRange from '@/components/InputRange';
import Select from '@/components/Select';
import Radio from '@/components/Radio';
import RadioGroup from '@/components/RadioGroup';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import { FILTER_LIMIT_VALUES } from '@/constants';

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    conversionType: {
      type: String,
      required: true
    },
    dataType: {
      type: String,
      required: true
    },
    defaultValue: {
      type: Object,
      required: true
    },
    range: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    storedFilters: {
      type: Array,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Icon,
    InputTags,
    InputRange,
    Select,
    PerfectScrollbar,
    Radio,
    RadioGroup
  },
  data() {
    return {
      keywordMatchType: [
        {
          label: '完全一致',
          value: 'exactly'
        },
        {
          label: 'フレーズ一致',
          value: 'phrase'
        },
        {
          label: '除外',
          value: 'exclude'
        }
      ],
      urlMatchType: [
        {
          label: '前方一致',
          value: 'prefix'
        },
        {
          label: '部分一致',
          value: 'partial'
        },
        {
          label: '除外',
          value: 'exclude'
        }
      ],
      limit: {
        // 絞り込み条件のURLの最大値
        maxUrlLength: FILTER_LIMIT_VALUES.maxUrlLength,
        // 絞り込み条件のキーワードの最大値
        maxKeywordLength: FILTER_LIMIT_VALUES.maxKeywordLength,
        // 登録できる絞り込み条件の最大値
        maxFilterLength: FILTER_LIMIT_VALUES.maxFilterLength
      },
      errorMessage: '',
      temp: Object.assign({}, this.value),
      selectedFilterId: 'default'
    };
  },
  computed: {
    filters() {
      // 何も選択されていない状態のidをdefaultとし、以降保存された絞り込み条件がある場合はインデックスをvalueとして持つ
      const filters = this.storedFilters.map(filter => {
        return {
          label: filter.name,
          value: filter.id
        };
      });
      filters.unshift({ label: '-', value: 'default' });
      return filters;
    },
    isConversion() {
      return this.dataType === 'conversion';
    },
    isConversionAssisted() {
      return this.isConversion && this.conversionType === 'assisted';
    },
    isConversionDirect() {
      return this.isConversion && this.conversionType === 'direct';
    },
    isInflux() {
      return this.dataType === 'influx';
    }
  },
  watch: {
    value: {
      handler(value) {
        this.temp = Object.assign({}, value);
        this.$nextTick(() => {
          // PerfectScrollbarの表示が更新されなかったので
          setTimeout(() => {
            this.$refs.scroll.update();
          }, 1);
        });
        this.errorMessage = '';
      },
      deep: true
    },
    storedFilters: {
      // 選択中の条件が削除された場合はデフォルトに戻す
      handler() {
        if (
          this.selectedFilterId != 'default' &&
          this.storedFilters.findIndex(
            filter => filter.id === this.selectedFilterId
          ) == -1
        ) {
          this.changeFilter();
        }
      }
    },
    errorMessage: {
      // エラーメッセージを消すのに丁度いいトリガーがないので、3秒後に消すようにする
      handler() {
        if (this.errorMessage == '') {
          return;
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        });
      }
    }
  },
  methods: {
    addUrl() {
      if (process.env.VUE_APP_ENV === 'demo') {
        return;
      }
      const urlMatch = this.urlMatchType.find(
        type => type.value === this.temp.urlMatch
      );
      const properties = {
        urls: this.temp.urls,
        urlMatch: urlMatch.label
      };
      amplitude
        .getInstance()
        .logEvent('Filter URL - Site Keyword Analysis', properties);
    },
    changeFilter() {
      // 保存条件が選ばれた場合、いったん現時点の入力内容をリセット
      this.$emit('change', Object.assign({}, this.defaultValue));
      // デフォルトは何も選択されていない状態なので、フィルターの反映を行わない
      if (this.selectedFilterId == 'default') {
        return;
      }
      // 全フィルターからIDが一致するものを検索
      for (let sf of this.storedFilters) {
        if (sf.id == this.selectedFilterId) {
          const temp = sf.value;
          // GA4表示時に保存したCVとCVRの絞り込み条件を、直接CVと直接CVRと間接CVと間接CVRに適用する
          if (temp.conversion) {
            if (!temp.directConversion) {
              temp.directConversion = temp.conversion;
            }
            if (!temp.assistedConversion) {
              temp.assistedConversion = temp.conversion;
            }
          }
          if (temp.conversionRate) {
            if (!temp.directConversionRate) {
              temp.directConversionRate = temp.conversionRate;
            }
            if (!temp.assistedConversionRate) {
              temp.assistedConversionRate = temp.conversionRate;
            }
          }
          // 不要なデータを削除する
          delete temp.conversion;
          delete temp.conversionRate;

          this.temp = temp;
          this.change();
          this.filterItems();
          return;
        }
      }
      // 一致するフィルターがなかった場合はデフォルトを選択する
      this.selectedFilterId = 'default';
      this.filterItems();
    },
    change() {
      this.$emit('change', this.temp);
    },
    confirmTagInput() {
      this.$refs.inputKeywords.keypress();
      this.$refs.inputKeywords.enter();
      this.$refs.inputUrls.keypress();
      this.$refs.inputUrls.enter();
    },
    filterItems() {
      this.$emit('filterItems');
    },
    handleFilterClick() {
      this.confirmTagInput();
      this.filterItems();
    },
    reset() {
      this.$emit('change', Object.assign({}, this.defaultValue));
      this.selectedFilterId = 'default';
      this.filterItems();
    },
    save() {
      if (
        this.$store.state.page.siteKeywordAnalysis[this.project.id] &&
        this.$store.state.page.siteKeywordAnalysis[this.project.id].filter &&
        this.$store.state.page.siteKeywordAnalysis[this.project.id].filter
          .length >= this.limit.maxFilterLength
      ) {
        this.errorMessage =
          '保存できる絞り込み条件は最大' +
          this.limit.maxFilterLength +
          '件です';
        return;
      } else if (this.temp.urls.length > this.limit.maxUrlLength) {
        this.errorMessage =
          '絞り込み条件に指定できるURLは最大' +
          this.limit.maxUrlLength +
          '件です';
        return;
      } else if (this.temp.keywords.length > this.limit.maxKeywordLength) {
        this.errorMessage =
          '絞り込み条件に指定できるキーワードは最大' +
          this.limit.maxUrlLength +
          '件です';
        return;
      }
      this.$emit('save');
    },
    handleSaveClick() {
      this.confirmTagInput();
      this.save();
    },
    openDeleteModal() {
      this.$emit('openDeleteModal');
    }
  }
};
</script>
